import { useMutation, useQueryClient } from "react-query";
import { getSurvey, getSurveys } from "./queryKey";
import axiosLib from "../../axiosLib";
import { API_URL } from "../../config";

export const createSurveyRequest = async (data) => {
  const response = await axiosLib.post(`${API_URL}/survey/initiate`, data);
  if (response.data.success) {
    return response.data.survey;
  }
  return null;
};

export const updateSurveyRequest = async ({ surveyId, data }) => {
  const response = await axiosLib.put(`${API_URL}/survey/${surveyId}`, data);
  if (response.data.success) {
    return response.data.survey;
  }
  return null;
};

export const useCreateSurvey = (userId) => {
  const queryClient = useQueryClient();
  return useMutation(createSurveyRequest, {
    onSettled: () => {
      queryClient.invalidateQueries(getSurvey(userId));
    },
    onSuccess: async () => {
      queryClient.invalidateQueries(getSurvey(userId));
      queryClient.invalidateQueries(getSurveys(userId));
    },
  });
};

export const useUpdateSurvey = (userId) => {
  const queryClient = useQueryClient();
  return useMutation(updateSurveyRequest, {
    onSettled: () => {
      queryClient.invalidateQueries(getSurvey(userId));
    },
    onSuccess: async () => {
      queryClient.invalidateQueries(getSurvey(userId));
      queryClient.invalidateQueries(getSurveys(userId));
    },
  });
};